import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { getStorage } from '../utils/functions/localstorage';

const useAuth = () => {
  const token = getStorage('token');
  return token;
};

function ProtectedRoutesEEntry() {
  const isAuth = useAuth();
  return isAuth ? <Outlet /> : <Navigate to="/e-entry/login" />;
}

export default ProtectedRoutesEEntry;
